export default "__VITE_ASSET__Bhy4thnd__"